import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import type { RootState } from '../../../store/store';
import { resolveAuthenticatedPath } from '../userRoles';
import AuthenticatedRoute from './AuthenticatedRoute';

type ProtectedRouteProps = {
  children: React.ReactNode;
};

function ProtectedRouteContent({ children }: ProtectedRouteProps): React.ReactElement {
  const location = useLocation();
  const user = useSelector((s: RootState) => s.auth.user);
  const requestedPath = location.pathname + location.search;

  const redirectPath = resolveAuthenticatedPath(user, requestedPath);
  if (redirectPath !== requestedPath) {
    return <Navigate to={redirectPath} replace />;
  }

  return <>{children}</>;
}

// Guards private routes against unauthenticated access and then enforces
// route-level role boundaries on the authenticated user.
export default function ProtectedRoute({ children }: ProtectedRouteProps): React.ReactElement {
  return (
    <AuthenticatedRoute loadingTestId="protected-route-loading-screen">
      <ProtectedRouteContent>{children}</ProtectedRouteContent>
    </AuthenticatedRoute>
  );
}
